import { Component, EventEmitter, forwardRef, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
    selector: "app-multi-select-dropdown",
    templateUrl: "./multi-select-dropdown.component.html",
    styleUrls: ["./multi-select-dropdown.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MultiSelectDropdownComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class MultiSelectDropdownComponent
  implements ControlValueAccessor, OnChanges
{
  @Input() data: any[] = [];
  @Input() settings: any = {};
  @Input() placeholder = "Select";
  @Input() disabled = false;
  @Input() showArrow = true;

  @Output() selectionChange = new EventEmitter<any[]>();
  @Output() dropdownClose = new EventEmitter<void>();
  @Output() filterChange = new EventEmitter<string>();
  @Output() select = new EventEmitter<any>();
  @Output() deSelect = new EventEmitter<any>();
  @Output() selectAll = new EventEmitter<any[]>();
  @Output() deSelectAll = new EventEmitter<any[]>();

  value: any[] = [];
  mergedSettings: any = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["settings"] || changes["placeholder"]) {
      this.setMergedSettings();
    }
  }

  writeValue(value: any): void {
    this.value = Array.isArray(value) ? [...value] : [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelValueChange(items: any[]): void {
    this.value = Array.isArray(items) ? items : [];
    this.onChange(this.value);
    this.selectionChange.emit(this.value);
  }

  onDropdownClose(): void {
    this.onTouched();
    this.dropdownClose.emit();
  }

  onFilterValueChange(value: string): void {
    this.filterChange.emit(value);
  }

  onSelectItem(item: any): void {
    this.select.emit(item);
    this.selectionChange.emit(this.value);
  }

  onDeSelectItem(item: any): void {
    this.deSelect.emit(item);
    this.selectionChange.emit(this.value);
  }

  onSelectAllItems(items: any[]): void {
    this.selectAll.emit(items || []);
    this.selectionChange.emit(this.value);
  }

  onDeSelectAllItems(items: any[]): void {
    this.deSelectAll.emit(items || []);
    this.selectionChange.emit(this.value);
  }

  private setMergedSettings(): void {
    this.mergedSettings = {
      singleSelection: false,
      enableCheckAll: true,
      idField: "id",
      textField: "text",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
      searchPlaceholderText: `Search ${this.placeholder}`,
      noDataAvailablePlaceholderText: "No data found",
      maxHeight: 240,
      ...this.settings,
    };
  }

  private onChange: any = () => {};
  private onTouched: any = () => {};

  constructor() {
    this.setMergedSettings();
  }
}
